export enum BlogPostDirection {
  Previous = "previous",
  Next = "next",
}
